import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of as observableOf } from 'rxjs';
import { SessionStorage } from '../constants/session-storage';

/**
 * AuthenticationService
 * @description
 * This is auth service, responsible for managing the Authentication related task.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  isLoggedIn = false;
  constructor() {}

  /**
   * Check if used is authenticated or not
   */
  IsAuthUser(): boolean {
    if (
      window.sessionStorage[SessionStorage.ewUserToken] &&
      JSON.parse(window.sessionStorage[SessionStorage.ewUserToken]).authToken
    ) {
      this.isLoggedIn = true;
      return true;
    } else {
      return false;
    }
  }

  getUserDomain() {
    return window.sessionStorage[SessionStorage.selectedUserDomain];
  }

  /**
   * Save the logged in user domain to local storage
   * @param domain domain to store
   */
  setUserDomain(domain: any) {
    window.sessionStorage[SessionStorage.ewUserToken] = domain;
  }

  /**
   * Save the logged in user detail to local storage
   * @param token token to store
   */
  setLoginUserDetail(token: any) {
    const tokenObj = { authToken: token };
    window.sessionStorage[SessionStorage.ewUserToken] = JSON.stringify(
      tokenObj
    );
  }

  /**
   * Update token
   * @param data token to update
   */
  updateLoginUserDetail(data: any) {
    if (window.sessionStorage[SessionStorage.ewUserToken]) {
      const authObject = JSON.parse(
        window.sessionStorage[SessionStorage.ewUserToken]
      );
      // Update the user details here
      window.sessionStorage[SessionStorage.ewUserToken] = JSON.stringify(
        authObject
      );
    }
  }

  /**
   * Get user access token from local storage
   */
  getUserAccessToken() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.ewUserToken])
        .authToken;
    } else {
      return null;
    }
  }

  /**
   * Get user access token in decoded form
   */
  getDecodedUserAccessToken() {
    const token = this.getUserAccessToken();
    if (token) {
      return token;
    }
    return null;
  }

  /**
   * Get logged in user id from token
   */
  getLoginUserId() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token.userId;
    }
    return null;
  }

  /**
   * Get logged in user email from token
   */
  getLoginUserEmail() {
    if (window.sessionStorage[SessionStorage.ewUserToken]) {
      return JSON.parse(window.sessionStorage[SessionStorage.ewUserToken])
        .email;
    }
  }
  /**
   * Get logged in user plan from token
   */
  getLoginUserPlan() {
    if (window.sessionStorage[SessionStorage.ewUserToken]) {
      return JSON.parse(window.sessionStorage[SessionStorage.ewUserToken]).plan;
    }
  }

  /**
   * Gets login user name
   * @returns  user name
   */
  getLoginUserName() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token.userName;
    }
    return null;
  }

  /**
   * Gets login user selected business unit detail
   * @returns  business unit id and name
   */
  getLoginUserPermissions() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token.permissions;
    }
    return null;
  }

  /**
   * Delete user access token
   */
  deleteUserAccessToken() {
    window.sessionStorage.clear();
    return true;
  }

  /**
   * Clear local storage
   */
  logout(): Observable<boolean> {
    this.deleteUserAccessToken();
    this.isLoggedIn = false;
    return observableOf(true);
  }
}
